import { Phone, MapPin, Clock, Instagram, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useCookieConsentContext } from "@/contexts/CookieConsentContext";

export const Footer = () => {
  const { openPreferences } = useCookieConsentContext();

  return (
    <footer className="bg-navy-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">
              ShoreSight<span className="text-azure-500">Marine</span>
            </h3>
            <p className="text-sm text-gray-300 mb-4">
              Professional marine window and hatch specialists serving San Diego County.
            </p>
            <div className="flex gap-4">
              <a
                href="https://maps.app.goo.gl/Gw7tbib87Wv27L4c8"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-azure-500 transition-colors"
                aria-label="Google Business Profile"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/shoresightmarine"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-azure-500 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-6 w-6" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact Information</h4>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="flex items-start gap-2">
                <MapPin className="h-5 w-5 shrink-0 mt-0.5" />
                <a 
                  href="https://maps.app.goo.gl/GyCUnxD8oekkuSK37"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-azure-500 transition-colors"
                >
                  <p>2608 Shelter Island Dr Suite 302</p>
                  <p>San Diego, CA 92106</p>
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-5 w-5 shrink-0" />
                <a href="tel:6193774673" className="hover:text-azure-500 transition-colors">
                  (619) 377-4673
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-5 w-5 shrink-0" />
                <a 
                  href="mailto:info@shoresightmarine.com" 
                  className="hover:text-azure-500 transition-colors"
                >
                  info@shoresightmarine.com
                </a>
              </div>
              <div className="flex items-start gap-2">
                <Clock className="h-5 w-5 shrink-0 mt-0.5" />
                <div>
                  <p>Monday-Friday: 8:00 AM - 4:00 PM</p>
                  <p>Saturday-Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Service Area</h4>
            <p className="text-sm text-gray-300 mb-4">
              San Diego County, Orange County & nearby Southern California marinas
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-300">
          <p>© {new Date().getFullYear()} ShoreSight Marine Windows LLC. All rights reserved.</p>
          <div className="flex flex-wrap gap-4 md:gap-6 justify-center md:justify-end">
            <Link to="/terms" className="hover:text-azure-500 transition-colors text-center">
              Terms of Service
            </Link>
            <Link to="/privacy" className="hover:text-azure-500 transition-colors text-center">
              Privacy Policy
            </Link>
            <button 
              onClick={openPreferences}
              className="hover:text-azure-500 transition-colors"
            >
              Cookie Preferences
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
